module.exports = __webpack_public_path__ + "rosacea_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_4_before.jpg
// module id = 984
// module chunks = 0